import { maybeBundleOverride } from './bundleOverride';
import { ROUTER_BASENAME } from './dev-console/path-prefixes';
import { isFederalEnv } from './environment';
import { initTagManager } from './tag-manager';
const ConsoleImport = () => import('./dev-console');
const InstallImport = () => import('./forge-distribution');

const fetchAuth = async () => {
  const auth = await fetch('/gateway/api/me');
  if (auth.status === 401) {
    // User is not logged in
    const returnTo = `?returnTo=${encodeURIComponent(location.pathname + location.search)}`;
    location.href = `/account/login${returnTo}`;
    return;
  }
  return auth.json();
};
async function main() {
  // Handle the bundle override first, as the override can do everything else itself
  if (maybeBundleOverride()) {
    return;
  }
  if (!isFederalEnv()) {
    initTagManager();
  }

  injectRootElement();

  const authPromise = fetchAuth();
  let modulePromise: Promise<{ main: () => void }>;

  if (location.pathname.startsWith(`${ROUTER_BASENAME}/install/`)) {
    modulePromise = InstallImport();
  } else {
    modulePromise = ConsoleImport();
  }

  const [auth, module] = await Promise.all([authPromise, modulePromise]);
  setupAuth(auth);
  module.main();
}

function injectRootElement() {
  if (document.querySelector('#root')) {
    return;
  }
  const root = document.createElement('div');
  root.id = 'root';
  document.body.appendChild(root);
}

export interface CustomWindow extends Window {
  __DATA__?: Record<string, unknown>;
}

function setupAuth(auth: Record<string, string>) {
  (window as CustomWindow).__DATA__ = {
    account: {
      id: auth.account_id,
      email: auth.email,
      screenName: auth.name,
      avatarUrl: auth.picture,
    },
  };
}

void main();
